import script from "./NakasList.vue?vue&type=script&setup=true&lang=js"
export * from "./NakasList.vue?vue&type=script&setup=true&lang=js"

import "./NakasList.vue?vue&type=style&index=0&id=45f62614&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45f62614"]])

export default __exports__